














































import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import TimeSheetCard from './TimeSheetCard.vue';
import Placeholder from './Placeholder.vue';
import TimeSheetFilter from './TimeSheetFilter.vue';
import { TimeSheetRequest } from '@/models/timesheet/timesheetRequest';
import Datepicker from 'vuejs-datepicker';
import TimesheetEntry from './TimesheetEntry.vue';

declare var window: any;

@Component({
  name: 'TimeSheetList',
  components: {
    TimeSheetCard,
    Placeholder,
    TimeSheetFilter,
    Datepicker,
    TimesheetEntry,
  },
})
export default class TimeSheetList extends Vue {
  public startDate!: number;
  public endDate!: number;
  public startDateText: string = '';
  public endDateText: string = '';
  public searchText: string = '';
  private showDateFilter: boolean = false;
  public tabName: string = 'saved';
  $moment: any;
  mounted() {
    vxm.timesheet.fetchCandidateTimeSheets('Saved');
  }

  get timeSheets() {
    return vxm.timesheet.CandidateTimeSheets;
  }

  onUpdateSearchText(val, tab) {
    this.searchText = val;
    this.tabName = tab;
    this.filterTimeSheets();
  }

  onUpdateDates(startDate, endDate) {
    this.startDateText = startDate ? startDate.toString() : '';
    this.endDateText = endDate ? endDate.toString() : '';
    this.filterTimeSheets();
  }

  changeTab(tabName: string) {
    this.tabName = tabName;
    this.filterTimeSheets();
  }

  filterTimeSheets() {
    var timeSheetRequest = new TimeSheetRequest();
    timeSheetRequest.searchText = this.searchText;
    timeSheetRequest.tabName = this.tabName;
    if (typeof this.startDateText != 'undefined' && this.startDateText != null)
      this.startDate = vxm.utility.convertLocalTimeToUTC(
        new Date(this.startDateText),
      );
    if (typeof this.endDateText != 'undefined' && this.endDateText != null)
      this.endDate = vxm.utility.convertLocalTimeToUTC(
        new Date(this.endDateText),
      );
    timeSheetRequest.startDate = this.startDate;
    timeSheetRequest.endDate = this.endDate;
    vxm.timesheet.setCandidateTimeSheets([]);
    vxm.timesheet.filterCandidateTimeSheets(timeSheetRequest);
    this.showDateFilter = false;
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get tabs() {
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      const slideMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (option) => option.sectionKey === 'TIMESHEETS',
      );
      if (!slideMenu) {
        return [];
      }
      return slideMenu.subSections.map((option) => ({
        text: option.displayName,
        visibility: true,
        isActive: option.isActive,
        jobStatus: option.jobStatus,
        tabId: option.sectionKey,
      }));
    } else {
      return [
        {
          name: 'saved',
          text: 'Saved',
          showAddLink: true,
        },
        {
          name: 'submitted',
          text: 'Submitted',
          showAddLink: true,
        },
        {
          name: 'rejected',
          text: 'Rejected',
          showAddLink: false,
        },
        {
          name: 'approved',
          text: 'Approved',
          showAddLink: false,
        },
      ];
    }
  }

  get hasTimeSheets() {
    return vxm.timesheet.CandidateTimeSheets.length;
  }

  onLinkClick() {
    this.$bvModal.show('timesheet-entry-modal');
    vxm.timesheet.setEditTimeSheetId(0);
  }
}
